// Ta bort bilder med base64-encoding från editorn
export const removeBase64Images = (content) => {
  // Patternet hittar image taggar med base64-encodad bild som src ("|'|&quot;)
  const base64Regex = /(?:(&lt;|<)img\b[^>]*?\bsrc=(?:(?:["|'|&quot;](data:image\/[^;]+;base64,[^"]+)*["|'|&quot;]))[^>]*?\s*\/?(>|&gt;))/gi;

  // Spara borttagna bilder
  const strippedImages: string[] = [];

  // Rensa bort Base64 bilder men spara bilden i arrayen strippedImages
  const modifiedContent = content.replace(base64Regex, (matched) => {
    strippedImages.push(matched);
    return '';
  });

  return { modifiedContent, strippedImages };
};
